import { baseUrl } from "../../../boot/index";
import axios from "axios";

// delete TeleRoless 
export const deleteTeleRoles = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/crm/app/v1/delete-tele-sales/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// add TeleRoless
export const addTeleRoles = async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/create-tele-sales`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log({ error })
      throw error
    }
  }




// update Company
export const updateTeleRoles = async (ROWID, data) => {
  console.log("dataToUpdate",data)
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/crm/app/v1/update-tele-sales/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// total count Attendance
export const countTeleRoles = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-tele-sales`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Get Company by ID
export const getTeleRolesId = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/get-tele-sales-by-id/${id}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}